import React from 'react';
import { ArrowRight, CheckCircle } from 'lucide-react';
import { modalities } from '../data/mock';
import { businessInfo } from '../data/mock';

const Modalities = () => {
  const handleWhatsAppClick = (modalityName) => {
    const message = encodeURIComponent(
      `Olá! Vi o site e gostaria de saber mais sobre as aulas de ${modalityName} no Centro de Lutas Jardim da Penha. Poderia me passar os horários e valores?`
    );
    window.open(`https://wa.me/${businessInfo.whatsapp}?text=${message}`, '_blank');
  };

  return (
    <section id="modalidades" className="py-24 bg-bg-card">
      <div className="container mx-auto px-4 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="heading-2 text-brand-primary mb-4">
            Nossas Modalidades
          </h2>
          <p className="body-medium text-gray-400 max-w-3xl mx-auto">
            Do iniciante ao avançado. Escolha sua arte marcial e comece a evolução.
          </p>
        </div>

        {/* Modalities Scrollable Container (Mobile) / Grid (Desktop) */}
        <div className="flex overflow-x-auto pb-8 gap-6 snap-x snap-mandatory lg:grid lg:grid-cols-4 lg:pb-0 lg:overflow-visible no-scrollbar">
          {modalities.map((modality) => (
            <div
              key={modality.id}
              className="flex-shrink-0 w-[85vw] sm:w-[320px] lg:w-full snap-center group relative overflow-hidden rounded-2xl glass-card border-white/5 hover:border-brand-primary transition-all duration-300 shadow-2xl"
            >
              {/* Image */}
              <div className="relative h-72 overflow-hidden">
                <img
                  src={modality.image}
                  alt={modality.name}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent"></div>
              </div>

              {/* Content */}
              <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-black via-black/95 to-transparent pt-16">
                {/* Level Badge */}
                <div className="inline-block bg-brand-primary text-white rounded-full px-4 py-1.5 mb-3">
                  <span className="font-bold text-xs uppercase tracking-wide">{modality.level}</span>
                </div>

                <h3 className="text-2xl font-black text-white mb-2 drop-shadow-lg">
                  {modality.name}
                </h3>
                
                {modality.schedule && (
                  <p className="text-sm text-white font-medium mb-2 flex items-center drop-shadow-md">
                    <span className="mr-2">📅</span> {modality.schedule}
                  </p>
                )}
                
                {modality.price && (
                  <p className="text-lg text-brand-primary font-black mb-4 drop-shadow-lg">
                    💰 {modality.price}
                  </p>
                )}

                {/* CTA */}
                <button
                  onClick={() => handleWhatsAppClick(modality.name)}
                  className="btn-secondary w-full group text-sm py-2.5 font-bold"
                >
                  SABER MAIS
                  <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Modalities;
